import { DownloadIcon } from "lucide-react"

import { DownloadButton } from "@/components/documents/DownloadButton"

import type { CustomerApplications } from "@boundless/bl-api-client/customer/models"

type SummaryApplicationDownloadProps = {
  application: CustomerApplications
}

export function SummaryApplicationDownload({
  application,
}: SummaryApplicationDownloadProps) {
  return (
    <div className="mt-6 flex items-center justify-between rounded-xl bg-gray-100 p-6 px-6 py-3">
      <span className="font-medium">Boundless Application</span>
      <DownloadButton
        aria-label="Download application"
        filename="boundless-application.zip"
        url={application.downloadUrl}
        className="text-primary underline"
      >
        <DownloadIcon className="h-5 w-5" />
      </DownloadButton>
    </div>
  )
}
